/** Supplemental GA4 events: never synthesize page views or alter navigation. */
export function initDiscovery() {
  const send = (name, params) => { if (typeof window.gtag === 'function') window.gtag('event', name, params); };
  document.querySelectorAll('.nw-sidebar .nw-brief li').forEach(item => {
    const link = item.querySelector('a');
    if (link && new URL(link.href).pathname === location.pathname) item.remove();
  });
  document.querySelectorAll('.nw-sidebar .nw-brief__number').forEach((n, i) => { n.textContent = String(i + 1).padStart(2, '0'); });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || target.pathname === location.pathname || target.hash.startsWith('#/portal')) return;
    const recommendation = link.closest('[data-discovery="article-end"]');
    const placement = recommendation ? 'article-end' : link.closest('[data-discovery="sidebar"], .sidebar') ? 'sidebar' : link.closest('.post-content') ? 'article-body' : link.closest('[data-wla-priority-carousel]') ? 'hero' : link.closest('article') ? 'story-card' : 'navigation';
    send(recommendation ? 'recommendation_click' : 'internal_content_click', {
      placement, destination_path: target.pathname,
      link_type: link.hasAttribute('data-recommendation-position') ? 'article' : 'explore',
      position: Number(link.dataset.recommendationPosition) || undefined
    });
  });
  if (!('IntersectionObserver' in window)) return;
  const pending = new Map();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting, intersectionRatio}) => {
      clearTimeout(pending.get(target));
      if (!isIntersecting || intersectionRatio < 0.5) return;
      pending.set(target, setTimeout(() => {
        pending.delete(target);
        if (document.visibilityState !== 'visible') return;
        const isLink = target.matches('[data-recommendation-position]');
        send(isLink ? 'recommendation_impression' : 'article_end_reached', {
          placement: 'article-end',
          ...(isLink ? {destination_path: new URL(target.href).pathname, position: Number(target.dataset.recommendationPosition)} : {})
        });
        observer.unobserve(target);
      }, 1000));
    });
  }, {threshold: [0, 0.5]});
  document.querySelectorAll('.nw-read-next > header, [data-recommendation-position]').forEach(el => observer.observe(el));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') { pending.forEach(clearTimeout); pending.clear(); }
  });
}

/** Referrer visits are observable traffic, never a measurement of AI citations. */
export function trackAIReferral() {
  if (!document.referrer || typeof window.gtag !== 'function') return;
  try {
    const host = new URL(document.referrer).hostname.toLowerCase();
    const providers = {'chatgpt.com':'chatgpt', 'chat.openai.com':'chatgpt', 'perplexity.ai':'perplexity', 'www.perplexity.ai':'perplexity', 'claude.ai':'claude', 'gemini.google.com':'gemini', 'copilot.microsoft.com':'copilot'};
    if (providers[host]) window.gtag('event', 'ai_referral_visit', {provider: providers[host], landing_path: location.pathname});
  } catch { /* Missing or opaque referrer cannot establish a source. */ }
}
